import React from "react";
import { useTranslation } from "react-i18next";
import d1070_fullFace from "../../assets/img/product/CheckID_D1070/fullFace.png";
import { Box } from "@mui/material";
import {
  InfoDetail,
  OrtherProduct,
  TechnicalSpecifications,
} from "../../components/products";
import pressure from "../../assets/img/product/pressure.png";
import height from "../../assets/img/product/height.png";
import weight from "../../assets/img/product/weight.png";
import BMI from "../../assets/img/product/BMI.png";
import tempture from "../../assets/img/product/tempture.png";
import spo2 from "../../assets/img/product/spo2.png";

export const CheckIDD1070 = () => {
  // set Title
  document.title = "Medical Examination Kiosk(CheckID -D1070) | CheckID";
  const { t } = useTranslation();
  const d1070Img = [d1070_fullFace];
  const infoDetail = {
    header: "products.d1070.infoDetail.header",
    model: "products.d1070.infoDetail.model",
    description: "products.d1070.infoDetail.description",
    function: [
      { name: "products.bloodPressure", image: pressure },
      { name: "products.height", image: height },
      { name: "products.weight", image: weight },
      { name: "BMI", image: BMI },
      { name: "products.temperature", image: tempture },
      { name: "products.bloodOxygen", image: spo2 },
    ],
  };
  const specification = [
    {
      item: "MAIN CONTROL",
      specification:
        "Industrial control motherboard, J6412, CPU main frequency 2.0GHz; 1 SO-DIMM /n 1 VGA, 1 HDMI; 9 USB interfaces, 4 RS232 interfaces, two 1000Mb adaptive /n Network cards, supporting TCP/IP protocol, DC12V /n Power on AutoStart, timed on/off function  ",
    },
    {
      item: "RAM",
      specification: "LPDDR4 1600MHz",
    },
    {
      item: "HARD DISK",
      specification: "256G SSD SATA",
    },
    {
      item: "MULTI-TOUCH",
      specification: "10.1-inch with capacitive touch technology",
    },
    {
      item: "CAPACITIVE DISPLAY",
      specification: "1280x800 resolution, /n USB Touch-Panel interface",
    },
    {
      item: "BLOOD PRESSURE NIBP",
      specification:
        "USB interface, DC12V, roll type, /n arm circumference 16cm—43cm, 0mmhg-300mmhg, /n systolic blood pressure: 8.0-30.7KPA, diastolic pressure: 5.3-17.3KPA, /n (ATM. pressure)860HPA-1060HAP  ",
    },
    {
      item: "3 CHANNELS ECG  ",
      specification: "Sampling 3 Leads simultaneously（1.5M cables）  ",
    },
    {
      item: "BLOOD OXYGEN  ",
      specification:
        "USB interface, DC5V, blood oxygen saturation range 70%-100%. accuracy±2%  ",
    },
    {
      item: "WEIGHT  ",
      specification: "RS485 interface, DC12V, range 200KG, accuracy 0.1KG  ",
    },
    {
      item: "HEIGHT  ",
      specification:
        "RS485 interface, DC12V, measuring range 8-200CM, Accuracy 0.1CM  ",
    },

    {
      item: "BODY TEMPERATURE  ",
      specification:
        "USB interface, DC5V, temperature measurement range 34-42.9 degrees, infrared sensing, distance 5-15CM, Accuracy 0.2 °C  ",
    },
    {
      item: "RECEIPT PRINTER  ",
      specification:
        "DC12V/2A, RS232/USB interface, paper width 58 mm, maximum roll diameter of 50mm, with paper near-end alarm, black mark detection & anti-jam function  ",
    },
    {
      item: "SPEAKERS  ",
      specification: "Support multimedia voice system  ",
    },
    {
      item: "POWER SUPPLY VOLTAGE  ",
      specification: "AC110V/220V, 300W  ",
    },
  ];
  return (
    <Box className="d1070">
      <Box className="d1070_info d-flex align-items-center">
        <Box>
          <h1 className="d1070_info-header">{t("products.d1070.header")}</h1>
          {/* <p className="d1070_info-title">{t("products.d1070.title")}</p> */}
        </Box>
        <img src={d1070_fullFace} alt="" className="d1070_info-img" />
      </Box>
      <InfoDetail
        classHeader="d1070"
        showImg={d1070Img}
        infoDetail={infoDetail}
      />
      <TechnicalSpecifications
        classHeader="d1070"
        specification={specification}
        type="type1"
      />
      <OrtherProduct classHeader="d1070" />
    </Box>
  );
};
